<template lang="pug">
  .array-input
    .panel.panel-default(v-if="nestedProps.length > 0")
      div(v-for="(np, index) in nestedProps")
        .panel-heading
          .panel-title {{ toSentence(propertyName) }} - {{ index + 1 }}
            span.glyphicon.glyphicon-remove.float-right-vertical-align.hoverable(title="Remove object" v-if="!disabled" @click="removeObject(index)")
        .panel-body
          ObjectInput(
            :key="generateUniqueKey()"
            :schema="property.items"
            :mappings="mappings"
            :metadata="np"
            :disabled="disabled"
            @update:data="update(np, index, arguments[0], arguments[1])")
    button.btn.btn-default.right-align(type="button" v-if="!disabled" @click="newObject") Add {{ toSentence(propertyName) }}
</template>

<script>
import Base from '../base'
import ObjectInput from '../ObjectInput'

export default {
  extends: Base,
  data: () => ({
    propertyValidity: [],
    nestedProps: []
  }),
  created() {
    if (this.localData) {
      this.nestedProps = this.localData
    }
  },
  methods: {
    generateUniqueKey() {
      return Math.ceil(Math.random(100000000))
    },
    removeObject(index) {
      this.nestedProps.splice(index, 1)
      this.propertyValidity.splice(index, 1)
    },
    update(np, index, value, isValid) {
      this.propertyValidity[index] = isValid
      const invalidProps = this.propertyValidity.filter((pv) => !pv && typeof pv !== 'undefined')
      this.$emit('update:data', this.nestedProps, invalidProps.length === 0)
    },
    newObject() {
      this.nestedProps.push({})
    }
  },
  accepts(property) {
    return property.type === 'array'
  },
  components: {
    ObjectInput
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/Array.vue